import background1 from './assets/background-1.png';
import background2 from './assets/background-2.png';
import background3 from './assets/background-3.png';
import background4 from './assets/background-4.png';
import background5 from './assets/background-5.png';
import template1 from './assets/template-1.png';
import template2 from './assets/template-2.png';
import template3 from './assets/template-3.png';
import template4 from './assets/template-4.png';
import template5 from './assets/template-5.png';

// 海报背景色属于可编辑的内容数据，来自主题素材，不用于界面 UI 配色。
export const posterThemes = [
  { id: '1', background: background1, thumbnail: template1, color: '#cddefa' },
  { id: '2', background: background2, thumbnail: template2, color: '#b494ff' },
  { id: '3', background: background3, thumbnail: template3, color: '#c7f49c' },
  { id: '4', background: background4, thumbnail: template4, color: '#ffb6ca' },
  { id: '5', background: background5, thumbnail: template5, color: '#ffe566' },
] as const;
